module.exports = __webpack_public_path__ + "img/telefono.e815ad0b.svg";